/* ============
 * Getters for the auth module
 * ============
 *
 * The getters that are available on the
 * auth module.
 *
 */
import { clone } from '@/utils/object';
import appProperties from '@/constants/app.properties';

const getOrganisationId = state => clone(state.user.organisation_id);
const getUser = state => clone(state.user);
const getAuthenticating = state => clone(state.isAuthenticating);
const getAuthenticated = state => clone(state.authenticated);
const getErrorMessage = state => state.error;
const isLoading = state => state.loading;
const getRolePermissions = state => state.access;
const getRole = state => (state.user && state.user.user_role ? state.user.user_role.name : null);
const getDefaultRoute = state => appProperties.DEFAULT_ROUTE_PATH[getRole(state)] || '';
const getCurrentModule = state => clone(state.currentModule);
const getModulePermissions = state => state.modulePermissions;

export default {
  getOrganisationId,
  getUser,
  getAuthenticating,
  getAuthenticated,
  getErrorMessage,
  isLoading,
  getRolePermissions,
  getDefaultRoute,
  getRole,
  getCurrentModule,
  getModulePermissions
};
